<script>
/**
 * Descripción: Componente Layout the la aplicación
 *
 * @displayName TheLayout
 */

const TheToolbar = () =>
  import(
    /* webpackChunkName: "layoutViewComponent" */ '@/components/core/layouts/TheToolbar'
  );

export default {
  name: 'TheLayout',

  components: {
    TheToolbar
  },

  data() {
    return {
      fab: false
    };
  },

  methods: {
    onScroll(e) {
      if (typeof window === 'undefined') return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },

    toTop() {
      this.$vuetify.goTo(0);
    }
  }
};
</script>

<template>
  <div id="app">
    <TheToolbar />

    <!-- Sizes your content based upon application components -->
    <v-main>
      <!-- Provides the application the proper gutter -->
      <v-container class="scroll-y">
        <slot name="RenderBody"></slot>
        <v-btn
          v-scroll="onScroll"
          v-show="fab"
          fab
          dark
          fixed
          bottom
          right
          color="#2c3e50"
          @click="toTop"
        >
          <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
      </v-container>
    </v-main>
  </div>
</template>
